/** Saved scope prose may use `## Title` to give a customer condition its own section.
 * Plain text stays unchanged; no HTML or other Markdown is executed. */
export function proposalCopySections(copy:string){
 const intro:string[]=[];const sections:{title:string;lines:string[]}[]=[];
 for(const raw of copy.split('\n')){const line=raw.trim();if(!line)continue;
  const heading=/^##\s+(.+)$/.exec(line);
  if(heading){sections.push({title:heading[1]!,lines:[]});continue;}
  (sections.at(-1)?.lines??intro).push(line);
 }
 return {intro,sections};
}
